const openModal = (modal) => {
  if (!modal) return

  modal.showModal()
  modal.children[0].scrollTop = 0
  modal.children[0].classList.remove("opacity-0")
  modal.children[0].classList.add("opacity-100")
  document.body.setAttribute("style", "overflow: hidden;")
}

const closeModal = (event) => {
  const modal = event.currentTarget.closest('dialog')

  modal.children[0].classList.remove("opacity-100")
  modal.children[0].classList.add("opacity-0")
  setTimeout(() => {
    modal.close()
    document.body.removeAttribute("style")
  }, 100)
}

document.addEventListener("ajax:success", (event) => {
  const [data] = event.detail

  if (data) {
    const modalWrapper = document.getElementById('modal')
    modalWrapper.innerHTML = data.content
    openModal(modalWrapper.firstElementChild)

    const clickCloseModal = document.querySelectorAll("[data-dismiss='modal']")
    if (clickCloseModal) {
      clickCloseModal.forEach(dismiss => {
        dismiss.addEventListener("click", closeModal)
      })
    }
  }
})
